$(document).ready(function() {
  $('select').not('[data-native-select]').niceSelect();
});
